(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    const breadcrumbFits = new Map();
  const mobileBreadcrumb = window.matchMedia('(max-width: 749px)');

  function initBreadcrumbFits() {
    for (const [nav, cleanup] of breadcrumbFits) {
      if (!nav.isConnected) {
        cleanup();
        breadcrumbFits.delete(nav);
      }
    }
    document.querySelectorAll('[data-breadcrumb-fit]').forEach(nav => {
      if (breadcrumbFits.has(nav)) return;
      const list = nav.querySelector('.gg-breadcrumb__list');
      const current = list?.querySelector('[aria-current="page"]');
      if (!list || !current) return;
      let frame = 0;
      const fit = () => {
        frame = 0;
        const items = Array.from(list.children);
        items.forEach(item => item.removeAttribute('data-breadcrumb-hidden'));
        if (!mobileBreadcrumb.matches || !list.clientWidth) return;
        const fits = () => list.scrollWidth <= list.clientWidth + 1 && current.scrollWidth <= current.clientWidth + 1;
        const optional = items.length > 2 ? [items[0], ...items.slice(2, -1)] : [];
        for (const item of optional) {
          if (fits()) break;
          item.setAttribute('data-breadcrumb-hidden', '');
        }
      };
      const schedule = () => {
        if (!frame) frame = requestAnimationFrame(fit);
      };
      const resize = new ResizeObserver(schedule);
      resize.observe(list);
      const content = new MutationObserver(schedule);
      content.observe(list, { childList: true, characterData: true, subtree: true });
      mobileBreadcrumb.addEventListener('change', schedule);
      document.fonts?.ready.then(schedule);
      document.fonts?.addEventListener('loadingdone', schedule);
      breadcrumbFits.set(nav, () => {
        cancelAnimationFrame(frame);
        resize.disconnect();
        content.disconnect();
        mobileBreadcrumb.removeEventListener('change', schedule);
        document.fonts?.removeEventListener('loadingdone', schedule);
      });
      fit();
    });
  }

  initBreadcrumbFits();
  document.addEventListener('shopify:section:load', initBreadcrumbFits);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(initBreadcrumbFits));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-sort"] && !Shopify.designMode) return;
  try {
    const preserveCollectionTag = (event) => {
    const collection = event.target.closest('gg-collection');
    if (!collection) return;
    const form = collection.querySelector('[data-cc-form]');
    if (event.target === form || event.target.form === form) collection.dataset.url = window.location.pathname;
  };
  document.addEventListener('change', preserveCollectionTag, true);
  document.addEventListener('submit', preserveCollectionTag, true);
  document.addEventListener('change', (event) => {
    const sort = event.target.closest('.gg-collection-sort');
    if (sort && event.target.name === 'sort_by') sort.querySelector('summary')?.focus({ preventScroll:true });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["details-grammar"] && !Shopify.designMode) return;
  try {
    // Details lines written for one option value ("[Silvered Brass] Metal: …") follow the variant picker: the line of the
  // chosen value shows, the others hide. Values compare trimmed and lowercased, as the Liquid above writes them.
  document.addEventListener('change', (event) => {
    const picker = event.target.closest && event.target.closest('gg-variant-picker');
    if (!picker) return;
    const chosen = new Set([...picker.querySelectorAll('input[type="radio"]:checked')].map((input) => input.value.trim().toLowerCase()));
    document.querySelectorAll('.gg-details [data-details-when]').forEach((el) => {
      el.hidden = !el.dataset.detailsWhen.split('|').some((value) => chosen.has(value));
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hero-campaign-title"] && !Shopify.designMode) return;
  try {
    function initCampaignInk() {
    const hero = document.querySelector('.gg-campaign-title');
    if (!hero || hero.dataset.inkReady) return;
    hero.dataset.inkReady = 'true';
    const copy = hero.querySelector('.gg-campaign-title__copy');
    const explore = hero.querySelector('.gg-campaign-title__explore');
    const section = hero.closest('.shopify-section');
    const arrivals = section?.nextElementSibling?.querySelector('gg-rail');
    let pending = false;
    let shift = 0;
    let target = 0;
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const connectGrid = (surface, cells) => {
      if (!surface) return;
      const box = surface.getBoundingClientRect();
      const rects = Array.from(cells).map(el => el.getBoundingClientRect());
      const firstY = Math.min(...rects.map(r => r.top));
      const positions = [...new Set(rects.filter(r => Math.abs(r.top - firstY) < 2 && r.left > box.left + 2).map(r => ((r.left-box.left)/box.width*100).toFixed(4)))];
      surface.style.backgroundImage = surface === hero ? 'none' : positions.map(() => 'linear-gradient(var(--hairline),var(--hairline))').join(',');
      surface.style.backgroundSize = positions.map(() => '1px var(--campaign-edge-depth)').join(',');
      surface.style.backgroundPosition = positions.map(x => (Number(x) * box.width / 100) + 'px bottom').join(',');
      surface.style.backgroundRepeat = 'no-repeat';
      const media = surface.querySelector('.gg-campaign-title__film') || surface.querySelector(':scope > .srlm-experience');
      if (media && box.width) {
        const boundaries = surface === hero ? [0, box.width] : [0, ...positions.map(x => Number(x)*box.width/100), box.width].sort((a,b)=>a-b);
        const step = box.width / (box.width <= 749 ? 20 : 40);
        let path = 'M0 0';
        for (let i=1;i<boundaries.length;i++) {
          const start=boundaries[i-1], end=boundaries[i], count=Math.max(1,Math.round((end-start)/step)), width=(end-start)/count;
          for(let j=0;j<count;j++) {
            const x=start+j*width, mid=x+width/2, right=x+width;
            path += 'C'+(x+width*13/76)+' 24 '+(mid-width*11/76)+' 38 '+mid+' 38S'+(right-width*13/76)+' 24 '+right+' 0';
          }
        }
        path += 'V0H0Z';
        const svg='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 '+box.width+' 38" preserveAspectRatio="none"><path fill="white" d="'+path+'"/></svg>';
        const mask='linear-gradient(#fff 0 0), url("data:image/svg+xml,'+encodeURIComponent(svg)+'")';
        media.style.maskImage=mask;
        media.style.webkitMaskImage=mask;
        media.style.maskSize='100% calc(100% - var(--campaign-edge-depth) - var(--curtain-lift, 0px) + .5px), 100% var(--campaign-edge-depth)';
        media.style.webkitMaskSize=media.style.maskSize;
        media.style.maskPosition='left top, left calc(100% - var(--curtain-lift, 0px))';
        media.style.webkitMaskPosition=media.style.maskPosition;
        media.style.maskRepeat='no-repeat';
        media.style.webkitMaskRepeat='no-repeat';
        if (surface === hero) {
          const depth = box.width * (box.width <= 749 ? .025 : .0125);
          const height = hero.offsetHeight;
          const join = height - depth;
          const silhouette = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 '+box.width+' '+height+'" preserveAspectRatio="none"><path fill="white" d="M0 0H'+box.width+'V'+join+'H0Z"/><g transform="translate(0 '+(join-.25)+') scale(1 '+(depth/38)+')"><path fill="white" d="'+path+'"/></g></svg>';
          media.style.maskImage = 'url("data:image/svg+xml,'+encodeURIComponent(silhouette)+'")';
          media.style.webkitMaskImage = media.style.maskImage;
          media.style.maskSize = '100% calc(100% - var(--curtain-lift, 0px))';
          media.style.webkitMaskSize = media.style.maskSize;
          media.style.maskPosition = 'left top';
          media.style.webkitMaskPosition = 'left top';
        }

      }
    };
    const grid = () => {
      connectGrid(hero, []);
      connectGrid(document.querySelector('.gg-hchapter--campaign-link'), document.querySelectorAll('.gg-footer__grid > *'));
      document.querySelectorAll('gg-rail[id$="__art"]').forEach(rail => {
        const film = rail.closest('.shopify-section')?.previousElementSibling?.querySelector('.gg-hchapter');
        connectGrid(film, rail.querySelectorAll('.gg-rail__head > *, .gg-rail__tools > *'));
      });
    };
    const editing = () => {
      const root = document.documentElement;
      return root.classList.contains('gg-lab-on') && !root.classList.contains('gg-lab-preview') && !root.classList.contains('gg-editor-hidden');
    };
    const paint = () => {
      pending = false;
      const y = window.scrollY;
      document.body.style.setProperty('--campaign-white', Math.min(100, Math.max(0, y / 2)) + '%');
      document.body.toggleAttribute('data-campaign-scrolled', y > 24);
      if (!arrivals || !copy) return;
      const rect = hero.getBoundingClientRect();
      const top = rect.top + y - shift;
      const header = document.querySelector('.gg-header')?.getBoundingClientRect();
      const dockBottom = Math.max(0, header?.height || 0);
      // Layout offsets do not include the parallax transforms from the previous frame.
      const lowerSpace = Math.max(16, hero.offsetHeight - copy.offsetTop - copy.offsetHeight);
      const mobileCurtain = rect.width <= 749;
      target = Math.max(0, mobileCurtain ? top + rect.height * .18 - dockBottom : top + copy.offsetTop - dockBottom - lowerSpace);
      const distance = Math.max(1, top + rect.height - dockBottom - target);
      const travel = Math.min(distance, Math.max(0, y - target));
      const progress = travel / distance;
      const active = !editing() && !reducedMotion.matches;
      // The film lags behind normal scroll; its mask closes by exactly the same
      // amount, keeping the toothed edge joined to the collection in document flow.
      shift = active ? travel * (mobileCurtain ? .809017 : .618034) : 0;
      hero.toggleAttribute('data-campaign-pinned', active && progress > 0 && progress < 1);
      hero.style.setProperty('--campaign-pin-y', shift + 'px');
      hero.style.setProperty('--curtain-lift', shift + 'px');
      hero.style.setProperty('--curtain-copy-y', (active ? -travel * (mobileCurtain ? .381966 : .236068) : 0) + 'px');
      hero.style.setProperty('--curtain-copy-opacity', active ? String(1 - Math.min(1, progress * 2.618034)) : '1');
    };
    const scroll = () => {
      if (!pending) { pending = true; requestAnimationFrame(paint); }
    };
    const go = () => {
      if (editing()) return;
      const destination = hero.dataset.campaignTarget && document.querySelector(hero.dataset.campaignTarget);
      if (destination) {
        destination.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        return;
      }
      paint();
      window.scrollTo({ top: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    explore?.addEventListener('click', go);
    window.addEventListener('resize', scroll, { passive: true });
    const observer = new ResizeObserver(() => { scroll(); grid(); });
    observer.observe(hero);
    if (arrivals) observer.observe(arrivals);
    window.addEventListener('scroll', scroll, { passive: true });
    reducedMotion.addEventListener('change', scroll);
    paint();
    grid();
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(hero)) { reducedMotion.removeEventListener('change', scroll); window.removeEventListener('scroll', scroll); window.removeEventListener('resize', scroll); observer.disconnect(); explore?.removeEventListener('click', go); document.body.removeAttribute('data-campaign-scrolled'); document.body.style.removeProperty('--campaign-white'); }
    });
  }
  initCampaignInk();
  document.addEventListener('shopify:section:load', initCampaignInk);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["knitwear-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('srlm-size-guide')) {
    customElements.define('srlm-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.querySelector('.srlm-fit__units').hidden = false;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-unit]');
          if (!button || !this.contains(button)) return;
          const unit = button.dataset.unit;
          const format = new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 1 });
          this.querySelectorAll('button[data-unit]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          this.querySelectorAll('[data-cm]').forEach((cell) => {
            const cm = Number(cell.dataset.cm);
            cell.textContent = format.format(unit === 'in' ? cm / 2.54 : cm);
          });
          const label = this.querySelector('[data-unit-label]');
          label.textContent = unit === 'in' ? label.dataset.inLabel : label.dataset.cmLabel;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["made-to-measure"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('srlm-tailoring')) {
    customElements.define('srlm-tailoring', class extends HTMLElement {
      connectedCallback() {
        this.control = this.querySelector('button');
        this.tip = this.querySelector('[role="tooltip"]');
        this.events = new AbortController();
        const on = (target, event, fn) => target.addEventListener(event, fn, { signal: this.events.signal });
        this.pinned = false;
        const enter = event => {
          if (event.pointerType === 'touch') return;
          clearTimeout(this.timer);
          this.show();
        };
        const leave = event => {
          if (event.pointerType === 'touch' || this.pinned || document.activeElement === this.control) return;
          this.timer = setTimeout(() => this.hide(), 150);
        };
        on(this.control, 'pointerenter', enter);
        on(this.control, 'pointerleave', leave);
        on(this.tip, 'pointerenter', enter);
        on(this.tip, 'pointerleave', leave);
        on(this.control, 'focus', () => this.show());
        on(this.control, 'blur', () => { if (!this.pinned) this.hide(); });
        on(this.control, 'click', () => {
          this.pinned = !this.pinned;
          if (this.pinned) this.show(); else this.hide();
        });
        on(document, 'click', event => { if (!this.contains(event.target)) this.hide(); });
        on(document, 'keydown', event => { if (event.key === 'Escape') this.hide(); });
        on(window, 'resize', () => this.hide());
        on(window, 'scroll', () => this.hide());
      }
      show() {
        clearTimeout(this.timer);
        if (!this.tip.matches(':popover-open')) this.tip.showPopover();
        const button = this.control.getBoundingClientRect();
        const tip = this.tip.getBoundingClientRect();
        this.tip.style.left = Math.max(16, Math.min(button.left, window.innerWidth - tip.width - 16)) + 'px';
        const below = button.bottom + 10;
        this.tip.style.top = (below + tip.height < window.innerHeight - 16 ? below : Math.max(16, button.top - tip.height - 10)) + 'px';
        this.control.setAttribute('aria-expanded', 'true');
      }
      hide() {
        clearTimeout(this.timer);
        this.pinned = false;
        this.tip.hidePopover();
        this.control.setAttribute('aria-expanded', 'false');
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.events?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["material-option"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('srlm-material')) customElements.define('srlm-material', class extends HTMLElement {
  connectedCallback() {
    this.control = this.querySelector('input'); this.tip = this.querySelector('[role="tooltip"]');
    if (!this.tip) return;
    this.events = new AbortController();
    const on = (target, event, fn) => target.addEventListener(event, fn, {signal:this.events.signal});
    on(this, 'pointerenter', e => { if(e.pointerType !== 'touch') this.show(); });
    on(this, 'pointerleave', e => { if(e.pointerType !== 'touch' && !this.pinned) this.timer = setTimeout(() => this.hide(), 180); });
    on(this.tip, 'pointerenter', () => clearTimeout(this.timer));
    on(this.tip, 'pointerleave', () => { if(!this.pinned) this.hide(); });
    on(this.control, 'focus', () => this.show());
    on(this.control, 'blur', () => { if(!this.pinned) this.hide(); });
    on(this.control, 'click', () => { this.pinned = true; this.show(); });
    on(document, 'pointerdown', e => { if(!this.contains(e.target)) this.hide(); });
    on(document, 'keydown', e => { if(e.key === 'Escape') this.hide(); });
    on(document, 'srlm-material-open', e => { if(e.detail !== this) this.hide(); });
    on(window, 'resize', () => this.hide());
    on(window, 'scroll', () => this.hide());
    const row = this.closest('.gg-pdp__chips'); if(row) on(row, 'scroll', () => this.hide());
  }
  show() {
    clearTimeout(this.timer);
    document.dispatchEvent(new CustomEvent('srlm-material-open', {detail:this}));
    if(!this.tip.matches(':popover-open')) this.tip.showPopover();
    const b=this.querySelector('label').getBoundingClientRect(), t=this.tip.getBoundingClientRect();
    this.tip.style.left=Math.max(12,Math.min(b.left+b.width/2-t.width/2,innerWidth-t.width-12))+'px';
    this.tip.style.top=(b.bottom+10+t.height < innerHeight-12 ? b.bottom+10 : Math.max(12,b.top-t.height-10))+'px';
  }
  hide() { clearTimeout(this.timer); this.pinned=false; if(this.tip?.matches(':popover-open')) this.tip.hidePopover(); }
  disconnectedCallback() { clearTimeout(this.timer); this.events?.abort(); }
});
  } catch(e) { console.error(e); }
})();

})();
